module.exports = __webpack_public_path__ + "public/images/emotions.5b8526963e8ae8a7df21a43292d36349.png";